<div class="row no-gutters">
  <div class="col-xxl-10 offset-xxl-1">

    <h1 class="collapser collapsed my-4" data-toggle="collapse" href="#Pricing" style="cursor:pointer">Nicola Wealth Investment Pricing & Update Schedule</h1>
    <div id="Pricing" class="collapse">
      <p>
        Nicola Wealth fund valuations are delayed at month-end while we await distributions. This delay ensures accurate valuations by synchronizing the price and distribution updates.<br>
        Market values and performance are updated on our website by 1PM daily using the latest price and transactions details received from our custodians.<br>
        The price is set in coordination with the trade frequency (e.g., Daily, Weekly, Monthly, Quarterly) and that price is used in calculating performance until the next price is received.<br>
        Unless otherwise disclosed in your Limited Partnership Agreement, all distributions are received monthly.
      </p>
      <div class="scrollable-wrap">
        <div class="scrollable">
          <div class="scrollable-button left"></div>
          <div class="scrollable-button"></div>
          <table width="100%" class="NWMtable table-hover">
            <thead>
              <tr>
                <td>Trade Frequency / Asset Classification</td>
                <td>Investment Name</td>
                <td>Currency</td>
                <td>Code</td>
              </tr>
            </thead>
            @if (buckets[0].Funds.length>0) {
              <tbody>
                @for (bucket of buckets; track bucket) {
                  <tr>
                    <td colspan="4" style="background:#f4f4f4"><b [innerHTML]="bucket.Title"></b></td>
                  </tr>
                  @for (fund of bucket.Funds; track fund) {
                    <tr>
                      <td>{{fund.SubClass}}</td>
                      <td [innerHTML]="fund.FundName"></td>
                      <td>{{fund.Currency}}</td>
                      <td>{{fund.FundCode}}</td>
                    </tr>
                  }
                }
              </tbody>
            }
          </table>
        </div>
      </div>
      <p class="text-right"><small>Updated 7/29/2024</small></p>
      <p>* Nicola Core Portfolio invests in Class "N" Units of the other Nicola Wealth Management Pools. The sub-asset classes of the underlying funds are reflected on your asset allocation.</p>
      <p>
        <sup>1</sup> Redemptions are subject to a minimum one-month notice period.<br>
        <sup>2</sup> Redemptions are subject to a minimum 6 month notice period.<br>
        <sup>3</sup> Redemptions are subject to an initial 3-year lock-up for investors and then a further 3-year vesting period for redemption proceeds.<br>
        <sup>4</sup> Fund opening may be subject to a waitlist.<br>
        <sup>5</sup> Closed-end Funds raises capital for investment through a one-time sale of a limited number of shares. These Funds are closed to purchases and redemptions.<br>
      </p>
      <p><b>For additional information regarding the Limited Partnerships please refer to the subscription agreement.</b></p>

    </div>
  </div>
</div>
